/**
 * Fields module - centralized field system for data tables and filters
 */
// Field repository
export { FieldRepository } from "./field-repository";
// Field formatter
export { formatFieldValue } from "./field-formatter";
// Field utilities
export { createCompositeKey, createFallbackField, extractFieldName, extractTableName, guessFieldLabel, guessFieldType, } from "./field-utils";
